import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgNetworkBusiness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M128 106.667c-11.755 0-21.333 9.579-21.333 21.333 0 11.755 9.579 21.333 21.333 21.333 11.755 0 21.333-9.579 21.333-21.333 0-11.755-9.578-21.333-21.333-21.333" />
    <path d="M426.667 256C473.728 256 512 217.728 512 170.667V85.333C512 38.272 473.728 0 426.667 0H85.333C38.272 0 0 38.272 0 85.333v85.333C0 217.728 38.272 256 85.333 256h149.333v88.363c-29.845 7.765-53.205 31.125-60.971 60.971H21.333C9.557 405.333 0 414.891 0 426.667S9.557 448 21.333 448h152.363c9.536 36.693 42.667 64 82.304 64s72.768-27.307 82.304-64h152.363c11.797 0 21.333-9.557 21.333-21.333s-9.536-21.333-21.333-21.333H338.304c-7.765-29.845-31.125-53.205-60.971-60.971V256zM128 192c-35.285 0-64-28.715-64-64s28.715-64 64-64 64 28.715 64 64-28.715 64-64 64m320-21.333c0 11.776-9.557 21.333-21.333 21.333h-128c-11.776 0-21.333-9.557-21.333-21.333s9.557-21.333 21.333-21.333h128c11.776-.001 21.333 9.557 21.333 21.333m-192-64c-11.776 0-21.333-9.557-21.333-21.333S244.224 64 256 64h128c11.776 0 21.333 9.557 21.333 21.333s-9.557 21.333-21.333 21.333H256z" />
  </svg>
);
const Memo = memo(SvgNetworkBusiness);
export default Memo;
